// extracted by mini-css-extract-plugin
export default {"container":"index_container__15gen","avatarContainer":"index_avatarContainer__vPhsC","avatarSvg":"index_avatarSvg__TWn2e","loadingText":"index_loadingText__yRgx8"};